import { __styles, mergeClasses } from "@griffel/react";
const useRootStyles = __styles({
  root: {
    mc9l5x: "f1w7gpdv",
    Bg96gwp: "fez10in",
    h46zdd: "fve0sb9"
  }
}, {
  d: [".f1w7gpdv{display:inline;}", ".fez10in{line-height:0;}"],
  m: [["@media screen and (-ms-high-contrast: black-on-white){.fve0sb9{fill:currentColor;}}", {
    m: "screen and (-ms-high-contrast: black-on-white)"
  }]]
});
export const useIconState = props => {
  const {
    title,
    primaryFill = "currentColor"
  } = props;
  const state = Object.assign(Object.assign({}, props), {
    title: undefined,
    fill: primaryFill
  });
  const styles = useRootStyles();
  state.className = mergeClasses(styles.root, state.className);
  if (title) {
    state['aria-label'] = title;
  }
  if (!state['aria-label'] && !state['aria-labelledby']) {
    state['aria-hidden'] = true;
  } else {
    state['role'] = 'img';
  }
  return state;
};